import { getEvents } from 'app/modules/claim/service';
import { FMIPResponse } from 'app/modules/claim/ui/tools/constants';
import { ACTION_TYPES } from 'app/modules/logistic/service/store/action';
import { dowloadFile } from 'app/shared/util/methode-util';
import { logisticApi } from '../api';
import { ILogisticModel } from '../model/logistic.model';

export const downloadOrGenerateBP = (logistic: ILogisticModel, imei: any, externalRef: any, brand: any) => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.GENERATE_BP,
    payload: logisticApi.downloadOrGenerateBP(logistic),
  });

  const { logisticResponse } = await getState().logistic;

  if (logisticResponse?.bonTransportBase64) {
    await dispatch(getEvents('CLAIM', logistic.claimNumber));
    dowloadFile(logisticResponse);
  } else {
    await dispatch({
      type: ACTION_TYPES.SHOW_GENERATE_BP_ERROR,
    });
  }
};

export const hideGenerateBPError = () => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.HIDE_GENERATE_BP_ERROR,
  });
};

export const mobileAppleGeolocationCheckAvailability = (logistic: ILogisticModel, imei: any) => async (dispatch, getState) => {
  const response = await logisticApi.mobileAppleGeolocationCheckAvailability(imei, logistic?.idProvider, logistic.subscriptionNumber, logistic.claimNumber);
  await dispatch({
    type: ACTION_TYPES.GET_GEOLOCALISATION,
    payload: response
  });
  if (response?.data?.status !== FMIPResponse.MAX_ATTEMPTS_REACHED &&
    response?.data?.status !== FMIPResponse.NOCONTROLE) {
    await dispatch({
      type: ACTION_TYPES.SHOW_GEOLOCALISATION_MODAL,
    });
  }
};

export const hideGeolocalisationModal = () => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.HIDE_GEOLOCALISATION_MODAL,
  });
};

export const mobileAppleGeolocalise = (logistic: ILogisticModel, imei: any) => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.GET_GEOLOCALISATION,
    payload: logisticApi.mobileAppleGeolocalise(imei, logistic?.idProvider, logistic.subscriptionNumber, logistic.claimNumber),
  });
  const { geolocalisation } = await getState().logistic;
  if (geolocalisation?.status === FMIPResponse.DISABLED) {
    await dispatch(getEvents('CLAIM', logistic.claimNumber));
  }
};

export const cleanGeolocalisationState = () => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.CLEAN_GEOLOCALISATION,
  });
};

export const checkIfExistBonTransport = bonTransportData => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.CHECK_EXIST_BON_TRANSPORT,
    payload: logisticApi.checkIfExistBonTransport(bonTransportData),
  });
};

export const resetBonTransport = () => dispatch => {
  dispatch({
    type: ACTION_TYPES.RESET_BON_TRANSPORT,

    payload: [],
  });
};
